import React, { useMemo } from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { Campaign, CurrentTapType } from "pages/admin/Campaigns/Campaigns"
import { useTranslation } from "react-i18next"

interface CampaignsTableProps {
  campaigns: Campaign[]
  isAllChecked: boolean
  checkedCampaigns: Campaign[]
  toggleAllCampaigns: () => void
  togglecheckedCampaignHandler: (campaign: Campaign) => void
  toggleActiveCampaign: (campaign: Campaign) => void
  editCampaignHandler: (campaign: Campaign) => void
  viewDetailsHandler: (campaign: Campaign) => void
  deleteCampaignHandler: (campaign: Campaign) => void
  location?: any
}

const CampaignsTable: React.FC<CampaignsTableProps> = ({
  campaigns,
  isAllChecked,
  checkedCampaigns,
  toggleAllCampaigns,
  togglecheckedCampaignHandler,
  toggleActiveCampaign,
  editCampaignHandler,
  viewDetailsHandler,
  deleteCampaignHandler,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllCampaigns}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: Campaign } }) => {
          return (
            <input
              onClick={() =>
                togglecheckedCampaignHandler(cellProps.row.original)
              }
              checked={Boolean(
                checkedCampaigns.find(c => c.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("campaigns_campaignTitle"),
        accessor: "title",
        filterable: true,
        filter: (rows: any[], id: string, filterValue: string) => {
          if (!filterValue || filterValue.trim() === '') return rows
          const searchTerm = String(filterValue).toLowerCase().trim()

          return rows.filter(row => {
            const { title, id } = row.original as Campaign
            const titleMatch = title.toLowerCase().includes(searchTerm)
            const idMatch = id.toLowerCase().includes(searchTerm)
            return titleMatch || idMatch 
          })
        },
        Cell: (cellProps: { row: { original: Campaign } }) => {
          return (
            <div className="d-flex flex-column align-items-start">
              <p className="mb-0">{cellProps.row.original.title}</p>
              <p className="mb-0">{cellProps.row.original.id}</p>
            </div>
          )
        },
      },
      {
        Header: t("campaigns_category"),
        accessor: "category",
        filterable: true,
        Cell: (cellProps: { row: { original: Campaign } }) => {
          return <>{cellProps.row.original.category}</>
        },
      },
      {
        Header: t("common_startToEnd"),
        accessor: "startDate",
        filterable: true,
        Cell: (cellProps: { row: { original: Campaign } }) => {
          return (
            <>
              {cellProps.row.original.startDate} To{" "}
              {cellProps.row.original.endDate}
            </>
          )
        },
      },
      {
        Header: t("common_periodTime"),
        accessor: "periodTime",
        filterable: true,
        Cell: (cellProps: { row: { original: Campaign } }) => {
          return <>{cellProps.row.original.periodTime}</>
        },
      },
      {
        Header: t("common_price"),
        accessor: "price",
        filterable: true,
        Cell: (cellProps: { row: { original: Campaign } }) => {
          return <>{cellProps.row.original.price}</>
        },
      },
      {
        Header: t("common_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: Campaign } }) => {
          const { status, id } = cellProps.row.original
          return (
            <div className="form-check form-switch mb-3">
              {status === CurrentTapType.ended ? (
                <span className="badge text-success bg-success-30 me-1 px-2 py-1 font-size-10">
                  {t(status)}
                </span>
              ) : (
                <>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`customSwitch${id}`}
                    checked={status === CurrentTapType.active}
                    onClick={() => toggleActiveCampaign(cellProps.row.original)}
                  />
                  <label
                    className="form-check-label text-capitalize"
                    htmlFor={`customSwitch${id}`}
                  >
                    {t(status)}
                  </label>
                </>
              )}
            </div>
          )
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Campaign } }) => {
          const campaign = cellProps.row.original
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-vertical font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem onClick={() => editCampaignHandler(campaign)}>
                  <span className="">{t("common_edit")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => viewDetailsHandler(campaign)}>
                  <span className="">{t("common_viewDetails")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => deleteCampaignHandler(campaign)}>
                  <span className="text-danger">{t("campaigns_deleteCampaign")}</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        },
      },
    ],
    [campaigns, t, checkedCampaigns]
  )

  return (
    <TableContainer
      columns={columns}
      data={campaigns}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

CampaignsTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(CampaignsTable))
